import {ListItem} from '@chakra-ui/react';

export default function ChakraListItem({children, ...rest}) {
    return <ListItem {...rest}>{children}</ListItem>;
}
